<div class="row justify-content-center p-0 m-0">
  <div class="col-12 col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 p-0 m-0">
    <quick-preview-panel
      [heading]="'Password Reset'"
      [color]="'primary'"
    >
      <form [formGroup]="formGroup" class="p-4 m-0">
        <div class="mb-4">
          Please, choose a new password. If the operation is successful, you will be asked to login using your
          newly chosen password.
        </div>
         <div>
            <mat-form-field class="d-block">
              <mat-label>Old Password</mat-label>
              <input type="password" matInput class="d-block" autocomplete="on"
                     formControlName="oldPassword">
              <mat-error>
                Required field
              </mat-error>
            </mat-form-field>
          </div>
         <div>
            <mat-form-field class="d-block">
              <mat-label>New Password</mat-label>
              <input type="password" matInput class="d-block" autocomplete="on"
                     formControlName="newPassword">
              <mat-error>
                Required field
              </mat-error>
            </mat-form-field>
          </div>
         <div>
            <mat-form-field class="d-block">
              <mat-label>New Password (Confirm)</mat-label>
              <input type="password" matInput class="d-block" autocomplete="on"
                     formControlName="newPasswordConfirm">
              <mat-error>
                Required field
              </mat-error>
            </mat-form-field>
          </div>
         <div>
            <mat-error *ngIf="formGroup.hasError('confirmMismatch')">
              New password and its confirmation do not match.
            </mat-error>
          </div>
      </form>
      <actions-container>
        <div class="p-4">
          <button [color]="'primary'" [disabled]="!formGroup.valid" mat-raised-button color="primary" class="me-2"
            (click)="submit()"
          >Reset</button>
          <back-button></back-button>
        </div>
      </actions-container>
      <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>
    </quick-preview-panel>
    <div class="my-4" *ngIf="error">
      <error-panel [error]="error"></error-panel>
    </div>
  </div>
</div>
